import { API_CALL } from '../../middleware/api';

const GET_LIST_DOCUMENTS = 'get-list-documents';
export const GET_LIST_DOCUMENTS_RESULT = `${GET_LIST_DOCUMENTS}/result`;
export const GET_LIST_DOCUMENTS_ERROR = `${GET_LIST_DOCUMENTS}/error`;

const GET_DOWNLOAD_URL = 'get-download-link';
export const GET_DOWNLOAD_URL_RESULT = `${GET_DOWNLOAD_URL}/result`;
export const GET_DOWNLOAD_URL_ERROR = `${GET_DOWNLOAD_URL}/error`;

const GET_UPLOAD_URL = 'get-upload-link';
export const GET_UPLOAD_URL_RESULT = `${GET_UPLOAD_URL}/result`;
export const GET_UPLOAD_URL_ERROR = `${GET_UPLOAD_URL}/error`;

const DELETE_DOCUMENT = 'delete-document';
export const DELETE_DOCUMENT_RESULT = `${DELETE_DOCUMENT}/result`;
export const DELETE_DOCUMENT_ERROR = `${DELETE_DOCUMENT}/error`;

export const documentsActions = {
  getCloudListDocuments: patientId => ({
    [API_CALL]: {
      endpoint: `portal/patients/${patientId}/documents/list`,
      method: 'get',
    },
    type: GET_LIST_DOCUMENTS,
  }),

  getCloudDownloadUrl: (patientId, fileName) => ({
    [API_CALL]: {
      endpoint: `portal/patients/${patientId}/documents/download?file_name=${fileName}`,
      method: 'get',
    },
    type: GET_DOWNLOAD_URL,
  }),

  getCloudUploadUrl: (patientId, fileName) => ({
    [API_CALL]: {
      endpoint: `portal/patients/${patientId}/documents/upload?file_name=${fileName}`,
      method: 'get',
    },
    type: GET_UPLOAD_URL,
  }),

  getCloudUploadPatientListUrl: fileName => ({
    [API_CALL]: {
      endpoint: `portal/patients/patients-list/upload?file_name=${fileName}`,
      method: 'get',
    },
    type: GET_UPLOAD_URL,
  }),

  getCloudListPatientList: () => ({
    [API_CALL]: {
      endpoint: `portal/patients/patients-list/list`,
      method: 'get',
    },
    type: GET_LIST_DOCUMENTS,
  }),

  getCloudDownloadPatientListUrl: (fileName, orgId) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patients-list/download?file_name=${fileName}&orgId=${orgId}`,
      method: 'get',
    },
    type: GET_DOWNLOAD_URL,
  }),

  deleteCloudDocument: (patientId, fileName) => ({
    [API_CALL]: {
      endpoint: `portal/patients/${patientId}/documents/delete?file_name=${encodeURIComponent(fileName)}`,
      method: 'delete',
    },
    type: DELETE_DOCUMENT,
  }),

  deleteCloudPatientListDocument: (fileName, orgId) => ({
    [API_CALL]: {
      endpoint: `portal/patients/patients-list/delete?file_name=${encodeURIComponent(fileName)}&orgId=${orgId}`,
      method: 'delete',
    },
    type: DELETE_DOCUMENT,
  }),
};
